import React from 'react';
import UnauthRoutes from './UnauthRoutes';
import { useSelector } from 'react-redux';
import { ROLE_ADMIN } from '../constants';
import AdminRoutes from './AuthRoutes/Admin';
import { removeToken } from '../utils';

const BaseRoutes = () => {
  const user = useSelector(state => state.user);

  if (!user) {
    return <UnauthRoutes />;
  }

  switch (user.role) {
    case ROLE_ADMIN.value:
      return <AdminRoutes />;
    default:
      removeToken();
      return <UnauthRoutes />; 
  }
};

export default BaseRoutes;